import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import studentReducer from "./studentSlice";
import teacherReducer from "./teacherSlice";
import attendanceReducer from "./attendanceSlice";
import userReducer from "./userSlice";
import classReducer from "./classSlice";
import themeSettingSlice from "./themeSettingSlice";
import sidebarSlice from "./sidebarSlice";
// import { attendance } from "../../common/selectoption/selectoption";
import mealReducer from "./mealSlice";
import teacherDashboardReducer from "./teacherDashboardSlice";
import academicYearReducer from "./academicYearSlice"
import sectionReducer  from "./sectionSlice";
import schoolReducer  from "./schoolSlice";
import teacherAttendanceReducer from "./teacherAtteandanceSlice"
import locationReducer from "./locationSlice"
import reportReducer from "./reportSlice"
import adminReducer from "./adminSlice"
import stateDistrictReducer from "./stateDistrictSlice"

export const store = configureStore({
	reducer: {
		auth: authReducer,
		classes: classReducer,
		sections:sectionReducer,
		students: studentReducer,
		teachers: teacherReducer,
		attendance: attendanceReducer,
		user: userReducer,
		themeSetting: themeSettingSlice,
		sidebarSlice: sidebarSlice,
		meals: mealReducer,
		teacherDashboard: teacherDashboardReducer,
		academicYear: academicYearReducer,
		school:schoolReducer,
		teacherAttendance:teacherAttendanceReducer,
		userLocation:locationReducer,
		reports: reportReducer,
		admin:adminReducer,
		stateDistrict:stateDistrictReducer

	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
